import React from "react"
import Chip from "../Chip"

interface Props {
    user?: Amity.User;
    disabledDriver: boolean;
    disabledProfile: boolean
}

const TableChip = ({ user, disabledDriver, disabledProfile }: Props) => {
    return (
        <div className="display-flex gap-5">
            {user?.metadata?.profileType === 'MANAGER' ? (
                <Chip
                    text="Gestor da frota"
                    icon="rioglyph rioglyph-role-management"
                    background="bg-black"
                />
            ) : (
                <Chip
                    text="Minha equipe"
                    icon="rioglyph rioglyph-role-management"
                    background="bg-status-working"
                    disabled={disabledDriver}
                />
            )}

            <Chip
                text="Trucker Assist"
                icon="rioglyph rioglyph rioglyph-phone"
                background="bg-status-driving"
                disabled={disabledProfile}
            />
        </div>
    )
};

export default TableChip;